// extracted by mini-css-extract-plugin
export default {"Image":"ImageWithLoader_Image__o3e1M","loader":"ImageWithLoader_loader__3WLu7"};